import apiClient from "../../utilities/apiService";
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Fetch user verification requests
export const fetchVerificationRequests = async (params) => {
  try {
    const response = await apiClient.get(
      `${BASE_URL}/admin/user/profileVerification/requests`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching verification requests:", error);
    throw error;
  }
};

// Update verification status
export const updateVerificationStatus = async (
  id,
  approved,
  rejected,
  reason = null
) => {
  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_BACKEND_URL}/admin/user/profileVerification/updateStatus/${id}`,
      {
        id,
        approved,
        rejected,
        reason,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating verification status:", error);
    throw error;
  }
};
